"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProfileSequencesModal;

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var _AsyncLoadingModal = _interopRequireDefault(require("crm_ui/loadingPlaceholders/AsyncLoadingModal"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _PromiseHandlers = require("UIComponents/core/PromiseHandlers");

var _SalesModalTabs = require("sales-modal/constants/SalesModalTabs");

var _SequenceActions = _interopRequireDefault(require("crm_ui/flux/sequences/SequenceActions"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var SalesModalAsync = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "sales-modal" */
    'sales-modal/roots/SalesModalRoot').then(function (SalesModalRoot) {
      return SalesModalRoot.RootComponent;
    });
  },
  LoadingComponent: function LoadingModal() {
    return _react.default.createElement(_AsyncLoadingModal.default, {
      expectedWidth: 980,
      expectedHeight: 636,
      loaderSize: "small"
    });
  },
  ErrorComponent: (0, _AsyncComponentErrorHandler.default)('sales-modal')
});

function ProfileSequencesModal(_ref) {
  var isOpen = _ref.isOpen,
      handleCloseModal = _ref.handleCloseModal,
      portal = _ref.portal,
      subject = _ref.subject,
      user = _ref.user;

  var _useContext = (0, _react.useContext)(_SubjectContext.SubjectContext),
      objectType = _useContext.objectType,
      subjectId = _useContext.subjectId;

  function handleEnroll(_ref2, updateEnrollmentProgress) {
    var enrollment = _ref2.enrollment,
        email = _ref2.email;
    enrollment = enrollment.set('userPlatform', 'CRM');

    _SequenceActions.default.enroll({
      email: email,
      sequence: enrollment,
      vid: Number(subjectId),
      objectType: objectType,
      subjectId: subjectId
    }).then(function (completedEnrollment) {
      updateEnrollmentProgress('complete', completedEnrollment);
      handleCloseModal();
    }).catch(function (err) {
      handleCloseModal();
      (0, _PromiseHandlers.rethrowError)(err);
    });
  }

  if (!isOpen) {
    return null;
  } // not needed in this case since we're just using sequences


  var insertLink = function insertLink() {};

  var insertTemplate = function insertTemplate() {};

  return _react.default.createElement(SalesModalAsync, {
    user: user,
    portal: portal,
    tab: _SalesModalTabs.SEQUENCES,
    platform: "CRM",
    recipient: (0, _ImmutableModel.getProperty)(subject, 'email'),
    supplementalObjectType: objectType,
    supplementalObjectId: subjectId,
    closeModal: handleCloseModal,
    enrollSequence: handleEnroll,
    insertLink: insertLink,
    insertTemplate: insertTemplate
  });
}

ProfileSequencesModal.propTypes = {
  isOpen: _propTypes.default.bool,
  handleCloseModal: _propTypes.default.func.isRequired,
  portal: _reactImmutableProptypes.default.map,
  subject: _SubjectType.default.isRequired,
  user: _reactImmutableProptypes.default.map
};
module.exports = exports.default;